RivalIQ.module('export', function (module, App, Backbone, Marionette, $, _, moment, s) {

    'use strict';

    const MAX_POSTS_TO_RETURN_DEFAULT = 1000;
    module.type = RivalIQ.enums.exportType;
    module.format = RivalIQ.enums.exportFormat;

    // NOTE exposed for testing
    module.getFilenameDateString = function () {
        return moment().format('YYYYMMDD');
    };

    function buildFilename(opts) {

        const filenameComponents = [
            opts.prefix,
            opts.appName,
            opts.title,
            opts.primaryMetric,
            opts.secondaryMetric,
            opts.channel,
            opts.sort,
            (opts.companyId ? RivalIQ.state.landscape.getCompanyById(opts.companyId).get('name') : null),
            opts.companyName,
            opts.landscapeName
        ];

        if (opts.timePeriod) {

            filenameComponents.push(formatTimePeriod(opts.timePeriod));
        }

        filenameComponents.push(module.getFilenameDateString());

        return _.compact(filenameComponents).join('_')
            .replace(/[.,+]/g, '')
            .replace(/\s/g, '_')
            .toLowerCase();
    }

    function formatTimePeriod(timePeriod) {

        const dateDisplayGlue = ' - ';
        const dateDisplayFormat = 'YYYYMMDD';
        return timePeriod.mainPeriodStart.format(dateDisplayFormat) +
            dateDisplayGlue + timePeriod.mainPeriodEnd.format(dateDisplayFormat);
    }

    /**
     * Builds a filename for export
     */
    module.filename = {
        MAX_LANDSCAPE_LENGTH: 20,
        base: function (opts) {

            return buildFilename(_.extend(opts || {}, {
                prefix: 'rivaliq'
            }));
        },
        forApp: function (app, options) {
            options = options || {};

            const components = {
                prefix: 'rivaliq',
                appName: s.underscored(app.name)
            };

            if (!options.omitLandscapeName) {
                components.landscapeName = RivalIQ.state.view.get('landscapeName');

                // NOTE truncate landscapeName so that the filename isn't excessively long
                components.landscapeName = components.landscapeName.substr(0, module.filename.MAX_LANDSCAPE_LENGTH);
            }

            if (options.includeFocusCompanyName) {
                components.companyName = RivalIQ.state.landscape.getFocusCompany().name;
            }

            return buildFilename(_.extend(components, options));
        },
        forCuration: function (curation, options) {
            return module.filename.forApp({
                name: curation.getIdentifier()
            }, options);
        },
        forWidget: function (curation, widgetAttrs, options) {
            const name = [(curation ? curation.getIdentifier() : ''), widgetAttrs.id || widgetAttrs.widgetId].join('_');
            return module.filename.forApp({
                name: name
            }, options);
        }
    };

    /**
     * Creates a controller suitable for handling export.
     * @param options
     * @returns {*}
     */
    module.createController = function (options) {
        return module.controllers.Controller.create(options);
    };

    function exportBodyClasses(curation) {
        return [
            'x-export-is-loading x-export',
            `x-export-${curation.getProp('format')}`,
            (curation.isPortrait() ? 'x-export-orientation-portrait' : 'x-export-orientation-landscape'),
            curation.getProp('exportWidthClass') || '',
            (curation.isFocus() ? 'x-export-curation' : 'x-export-widget')
        ].join(' ');
    }

    // NOTE exposed for testing
    module._exportDomPreparation = function (curation) {
        // add the 'export is loading' class to make screenshot wait until loading is complete
        $('body')
            .addClass(exportBodyClasses(curation))
            .children()
            .hide();
        document.body
            .appendChild($('#widgets-region')[0])
            .classList.add('container-fluid');

        listenToLoadingImages(curation);
    };

    module.startExport = function (curation) {
        // As a guard, only do this once. If we are asked to do this twice, fail the export. This can happen
        // if an export results in a navigation; we could remove this at some point (and make sure widgets-region
        // is not hidden), but I want to be conservative to start and not allow navigation during export.
        const me = this;
        if (me._exportStarted) {
            throw new Error('export started more than once');
        }
        me._exportStarted = true;

        module._exportDomPreparation(curation);
    };

    /*
     * Remove all non-widget layout nodes to make layout as simple as
     * possible
     */
    module.completeExport = function (curation) {
        $('body > :hidden').remove();
        $('.panel-loading.hide').remove();

        $.when(curation.getSlideElements()).done(function (elements) {
            $('body').data({
                elements: elements
            });

            pollForImages(curation).done(function () {
                $('body').removeClass('x-export-is-loading').addClass('x-export-is-complete');
            });
        });
    };

    module.failExport = function (error) {
        // remove the 'export is loading' class so screenshot doesn't wait the full timeout period
        $('body')
            .addClass('x-export-is-failed')
            .removeClass('x-export-is-loading');
        App.logger.error(`error during export: ${JSON.stringify(error)}`);
    };

    module.sortFormats = function (formats) {
        return _.filter(RivalIQ.enums.exportFormatSortOrder, function (f) {
            return _.includes(formats, f);
        });
    };

    module.schedule = function (config, options) {

        const scheduleModel = new module.models.ReportSchedule({
            report: config.buildScheduledReport(),
            schedule: new RivalIQ.models.Schedule({
                period: RivalIQ.enums.schedule.period.DAY
            }),
            advanced: new RivalIQ.export.models.AdvancedScheduleOptions()
        });
        scheduleModel.dashboardModel = config;

        scheduleModel.listenTo(scheduleModel, 'sync', function () {
            scheduleModel.trackExport(config);
            // Add to the data collection so other apps see this new model
            module.data.reportSchedules.add(scheduleModel);
        });

        const modalAttrs = _.defaults({
            model: scheduleModel,
            config: config
        }, options);

        const modal = new module.views.ScheduleModal(modalAttrs);

        App.execute('show:modal', modal);
    };

    const onExportFailed = function (model) {
        App.execute('alert:danger', model.exportErrorMsg);
    };

    const getExportSuccessMessage = function (model) {
        const account = RivalIQ.state.account;
        let exportSuccessMsg = model.exportSuccessMsg;
        let exportLimit = -1;
        const isCSVExport = model.get('format') === RivalIQ.export.format.CSV;
        if (!isCSVExport) {
            const exportProps = model.config.processExportProps ? model.config.processExportProps(model.config.getProps(), model.config.changed) : [];
            exportLimit = (exportProps.limit && exportProps.limit !== -1) ? exportProps.limit : exportLimit;
        } else {
            // look to see if there is an overriden csv export limit on the account
            const csvLimit = account.get('settings').maxPostsToReturn;
            exportLimit = csvLimit ? csvLimit : MAX_POSTS_TO_RETURN_DEFAULT;

            if (model.get('slides')?.[0]?.metricGroups?.[0]?.[0]?.dataSourceId === RivalIQ.metrics.new.enums.DataSourceIds.LISTENING_QUERY_SEARCH) {
                exportLimit = 1000; // This should match config.quidMonitorMaxResultsCSVLimit
            }
        }
        if ((exportLimit > 0) && (model.config.getProp('instanceId') || isCSVExport)) {
            // just include widgets that are in detail view or are csv exports
            exportSuccessMsg += `<br><br><p>Please note that the download is limited to a max of ${exportLimit} items.</p>`;
        }
        return exportSuccessMsg;
    };

    const onExportSucceeded = function (model) {
        App.execute('alert:info', getExportSuccessMessage(model));

        // if the account is in trial and we just did PPT, update the trial report count
        const account = RivalIQ.state.account;

        if (account.hasTrialReportLimits()) {

            account.incrementTrialReportCount();
            RivalIQ.execute('alert:info', [
                'You have used',
                account.get('trialReportCount'),
                'of',
                account.get('trialReportLimit'),
                'free exports during this trial.'
            ].join(' '));
        }

        // Add to the page download list
        if (model.action === 'download') {
            RivalIQ.state.user.addPendingDownload(model);
        }

        // Start polling. This will download the file when done if appropriate
        model.pollStatus();
    };

    /* Build up an export model and either display a modal to the user
     * or execute immediately depending on action
     *
     * Parameters:
     * action - download, email or schedule
     * format - png, pdf, png, csv
     * dashboardModel - model that describes how parameters, options, etc should be
     *          constructed.
     * modalOptions - options for the export modal
     */
    module.export = function (action, format, dashboardModel, modalOptions) {

        if (RivalIQ.state.account.isAtTrialReportLimit()) {
            return App.execute('show:modal', new module.views.ExportLimitModal());
        }

        // Builds the appropriate export model for the given action
        const exportModel = RivalIQ.export.models.Report.build(action, format, dashboardModel);

        exportModel.listenTo(exportModel, 'sync', function () {
            // Add to export collection for use by other apps
            module.data.exports.add(exportModel);
        });

        exportModel.listenTo(exportModel, 'save:failed', function () {
            onExportFailed(exportModel);
        });

        exportModel.listenTo(exportModel, 'save:succeeded', function () {
            exportModel.trackExport();
            onExportSucceeded(exportModel);
        });

        // If the current selected action does not require the dialog then skip it
        if (!exportModel.dialogRequired()) {
            return exportModel.save();
        }

        const modalAttrs = _.defaults({
            model: exportModel
        }, modalOptions);

        const modal = new module.views.ExportModal(modalAttrs);

        App.execute('show:modal', modal);
    };

    // create export delivery method helpers
    module.email = _.bind(module.export, module, module.type.EMAIL);
    module.download = _.bind(module.export, module, module.type.DOWNLOAD);

    // Listen for our custom loading image events and record the nodes that
    // triggered them.
    function listenToLoadingImages(curation) {
        curation.loadedImages = [];
        $('body').on('img.loaded img.error', function (e, img) {
            curation.loadedImages.push(img);
        });
    }

    function pollForImages(curation) {
        let iterations = 0;

        const deferred = new $.Deferred();

        const imgLoading = setInterval(function () {
            iterations++;

            const hasVideosPending = $('.x-video-loading').length;

            const maxIterations = (hasVideosPending ? 200 : 20); // wait a lot longer if there are videos on the page.

            // Check that all .img-armed images have triggered
            // a loading or error event
            const imagesLoaded = _.difference($('.img-armed'), curation.loadedImages).length === 0;
            if (iterations > maxIterations || (imagesLoaded && !hasVideosPending)) {
                clearInterval(imgLoading);

                const videoCount = $('video').length;
                App.logger.info(`Export: all images loaded: ${imagesLoaded} Image Count: ${curation.loadedImages.length}; Video Count: ${videoCount}`);
                deferred.resolve();
            }
        }, 100);

        return deferred;
    }

}, window.moment, window.s);
